import React, { useEffect } from 'react';
import { Link, Element } from 'react-scroll';
import FetaSection from '../Products/Feta/Feta';
import MyzithraSection from '../Products/Myzithra/Myzithra';
import CastelinoSection from '../Products/Castelino/Castelino';
import './HeroSection.styled.css';

const HeroSection = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section
        className="relative bg-cover bg-center text-white h-screen flex items-center justify-center"
        id="hero-section"
        style={{ backgroundImage: 'url(https://www.mygreekdish.com/wp-content/uploads/2013/05/Traditional-Greek-Salad-recipe-Horiatiki-Xoriatiki-1-scaled.jpg)' }}
      >
        {/* Background Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black to-transparent opacity-75"></div>

        {/* Main Content */}
        <div className="container mx-auto text-center relative z-10 px-4 sm:px-0 transform translate-x-6 -translate-y-8">
          {/* Large Artistic Heading with Animation */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold tracking-wider opacity-80 mb-4 text-gray-100 drop-shadow-2xl animate-fade-in-up">
            Taste <br /> Elikon.
          </h1>

          {/* Subheading with Abstract Style */}
          <p className="text-md sm:text-lg md:text-xl lg:text-2xl text-gray-300 mb-8 opacity-70 drop-shadow-md animate-fade-in-up animation-delay-2">
            Authentic Greek flavors.
          </p>

          {/* Scroll Down Button */}
          <Link
            to="feta-section"
            smooth={true}
            duration={500}
            className="flex items-center justify-center"
            >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-12 h-12 text-white animate-bounce">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </Link>
        </div>

      </section>

      <Element name="feta-section">
        <FetaSection />
      </Element>
      <Element name="myzithra-section">
        <MyzithraSection />
      </Element>
      <Element name="castelino-section">
        <CastelinoSection />
      </Element>
    </div>
  );
};

export default HeroSection;